export const CREATING_ALBUM = "CREATING_ALBUM";
export const UPDATING_ALBUM = "UPDATING_ALBUM";
export const ALBUM_CREATED = "ALBUM_CREATED";
export const ALBUM_UPDATED = "ALBUM_UPDATED";
export const ERROR_ALBUM_CREATE = "ERROR_ALBUM_CREATE";
export const ERROR_ALBUM_UPDATE = "ERROR_ALBUM_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
